import { render, staticRenderFns } from "./TypeComponentDialog.vue?vue&type=template&id=18239ec7&"
import script from "./TypeComponentDialog.vue?vue&type=script&lang=js&"
export * from "./TypeComponentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports